export const APPLY_BORDERS = 'apply-borders';
export const APPLY_ANIMATION = 'apply-animation';
export const MOBILE_CENTERED_HEADER = 'mobile-centered-header';
export const FORCE_TRANSPARENT_BACKGROUND = 'force-transparent-background';
export const FORCE_TRANSPARENT_CONTENT_BACKGROUND = 'force-transparent-content-background';
export const DISABLE_FULLSCREEN_MOBILE = 'disable-fullscreen-mobile';
export const FORCE_CENTRALIZATION = 'force-centralization';
export const APPLY_MAX_HEIGHT = 'apply-max-height';
export const FORCE_FULLSCREEN_TABLET = 'force-fullscreen-tablet';
export const APPLY_MODAL_CLOSING_ANIMATION = 'apply-modal-closing-animation';
export const APPLY_MOBILE_SHEET_MODAL = 'apply-mobile-sheet-modal'